module.exports = "/images/datepicker-prev.png?997cf027edbd2b5b296b20d56a2ceacc";